import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import CertificateCard from '../common/CertificateCard';

const APP_LOGIN = 'https://app.laudando.online/login';

const Hero = () => {
  const reduceMotion = useReducedMotion();
  return (
    <section className="w-full max-w-full overflow-hidden bg-paper px-4 pt-12 pb-12 sm:px-6 sm:pt-16 md:pt-28 md:pb-24">
      <div className="mx-auto grid w-full max-w-7xl min-w-0 items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <div className="min-w-0 max-w-full">
          <motion.h1 initial={reduceMotion ? false : { opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="mb-5 max-w-full break-words font-display text-[clamp(2.45rem,11.5vw,3.25rem)] font-bold leading-[0.98] tracking-[-0.035em] text-navy sm:mb-7 md:text-[62px] md:leading-[1.02] md:tracking-[-0.03em]">
            Do modelo ao laudo assinado <em className="font-display font-semibold text-selo">em minutos.</em>
          </motion.h1>
          <p className="mb-7 max-w-xl text-base leading-relaxed text-muted sm:text-lg">Para médicos e veterinários: monte o modelo uma vez e reaproveite local, assinatura e histórico em cada laudo.</p>
          <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
            <a href={APP_LOGIN} className="btn-convert w-full justify-center px-5 text-[15px] sm:w-auto sm:px-7 sm:text-base">Criar meu primeiro laudo <ArrowRight className="h-4 w-4 shrink-0" aria-hidden="true" /></a>
            <a href="#como-funciona" className="btn-secondary w-full justify-center px-5 text-[15px] sm:w-auto sm:px-7 sm:text-base">Ver o fluxo</a>
          </div>
          <div className="mt-6 grid max-w-full grid-cols-1 gap-2 text-sm text-muted min-[380px]:grid-cols-2 sm:mt-7 sm:flex sm:flex-wrap sm:gap-x-5 sm:gap-y-2">
            <span className="inline-flex min-w-0 items-center gap-1.5"><CheckCircle2 className="h-3 w-3 shrink-0 text-selo" aria-hidden="true" />Conta sem cartão</span>
            <span className="inline-flex min-w-0 items-center gap-1.5"><CheckCircle2 className="h-3 w-3 shrink-0 text-selo" aria-hidden="true" />Cancele quando quiser</span>
          </div>
        </div>

        <motion.div initial={reduceMotion ? false : { opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.55 }} className="relative min-w-0 max-w-full overflow-hidden sm:overflow-visible">
          <div className="absolute -inset-3 -z-10 rounded-[20px] bg-paper-alt sm:-inset-5 sm:rounded-[24px]" />
          <div className="relative min-w-0 max-w-full overflow-hidden rounded-card">
            <CertificateCard className="w-full max-w-full min-w-0 shadow-card" />
            <motion.div
              initial={reduceMotion ? { opacity: 1 } : { opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={reduceMotion ? { duration: 0 } : { delay: 1.05, duration: 0.32 }}
              className="absolute right-2 top-2 rounded-card bg-selo px-2 py-1 font-mono text-[8px] uppercase tracking-wider text-white shadow-card sm:right-4 sm:top-4 sm:px-3 sm:py-1.5 sm:text-[9px]"
            >
              Registrado
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
